// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../src-custom-solutions/streams-schedule/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../src-custom-solutions/streams-schedule/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.headline-publish-date{font-family:var(--font-family-system);font-size:11px;font-weight:600;color:var(--color-grey-1);line-height:1;margin-top:10px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
